import { CircleDotIcon, InfoIcon } from "lucide-react";
import { useRef, useState } from "react";

const REQUIREMENTS = [
  "Provide a clear well-lit image of entire document",
  "Document name and date of birth must match that of identity",
  "Expired document will not pass verification",
];

export default function DocumentInfo() {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const show = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setOpen(true);
  };

  const hide = () => {
    timeoutRef.current = setTimeout(() => setOpen(false), 100);
  };

  return (
    <span className="relative inline-block" onMouseEnter={show} onMouseLeave={hide}>
      <button
        type="button"
        className="text-primary hover:text-primary/90 focus:outline-none focus:ring-2 focus:ring-primary rounded-full"
        aria-label="Document requirements info"
        onFocus={show}
        onBlur={hide}
      >
        <InfoIcon className="h-4 w-4" />
      </button>

      {open && (
        <div className="absolute z-10 left-1/2 -translate-x-1/2 top-full mt-2 w-72 sm:w-96 max-w-[90vw]">
          <div className="rounded-lg border border-input bg-muted p-4 shadow-lg space-y-3">
            {REQUIREMENTS.map((req, i) => (
              <div key={i} className="flex space-x-2">
                <CircleDotIcon className="text-primary shrink-0 h-4 w-4 mt-1" />
                <span className="text-base font-semibold">{req}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </span>
  );
}
